import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { FakeText, TextField } from '@totalsoft/rocket-ui';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';
import { Table, TableCell, TableBody, TableRow, TableHead, Grid, Tooltip, Toolbar, IconButton, Typography } from '@mui/material';
import { Add, Delete } from '@mui/icons-material';

const IncomeSourceDetailValueListCard = props => {
  const { t } = useTranslation();
  const { loading, dispatch, detailIndex, detailId } = props;
  const { incomeItemDetailValues } = props;

  const onAddNewValueRow = () => {
    dispatch({
      type: 'OnDetailValueAdded',
      index: detailIndex,
      detailId: detailId
    });
  };
  const onDeleteValueRow = valueIndex => {
    if (window.confirm(t('IncomeSources.DeleteValue'))) dispatch({ type: 'OnDetailValueDeleted', index: detailIndex, valueIndex });
  };

  const onPropertyChanged = (detailValueName, propertyValue, detailIndex, detailValueIndex) => {
    dispatch({ type: 'OnDetailValuesChanged', detailValueName, propertyValue, detailIndex, detailValueIndex });
  };

  return (
    <>
      <Toolbar>
        <Grid container spacing={1} justifyContent='flex-start'>
          <Typography variant='subtitle1'>{t('IncomeSources.Detail.DetailValues.ValuesSubtitle')}</Typography>
        </Grid>
        <Grid container justifyContent='flex-end'>
          <Grid item>
            <Tooltip title={t('Tooltips.IncomeSource.AddDetailValue')}>
              <div>
                <IconButton color='primary' onClick={onAddNewValueRow}>
                  <Add />
                </IconButton>
              </div>
            </Tooltip>
          </Grid>
        </Grid>
      </Toolbar>
      <CardNoResultsWrapper content={incomeItemDetailValues}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('IncomeSources.Detail.DetailValues.Code')}</TableCell>
              <TableCell>{t('IncomeSources.Detail.DetailValues.Name')}</TableCell>
              <TableCell align='right'>{t('IncomeSources.Actions')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={2}>
                  <FakeText lines={10} />
                </TableCell>
              </TableRow>
            ) : (
              incomeItemDetailValues.map((item, idx) => {
                return (
                  <TableRow hover key={idx}>
                    <TableCell>
                      <TextField fullWidth value={item.code || ''} onChange={event => onPropertyChanged('code', event, detailIndex, idx)} />
                    </TableCell>
                    <TableCell>
                      <TextField fullWidth value={item.name || ''} onChange={event => onPropertyChanged('name', event, detailIndex, idx)} />
                    </TableCell>
                    <TableCell align='right'>
                      <Tooltip title={t('Tooltips.IncomeSource.DeleteDetailValue')}>
                        <IconButton color='primary' onClick={() => onDeleteValueRow(idx)}>
                          <Delete />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </CardNoResultsWrapper>
    </>
  );
};

IncomeSourceDetailValueListCard.propTypes = {
  loading: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  incomeItemDetailValues: PropTypes.array.isRequired,
  detailId: PropTypes.number,
  detailIndex: PropTypes.number
};

export default IncomeSourceDetailValueListCard;
